import * as React from "react"
import Box from "@mui/material/Box"
import Drawer from "@mui/material/Drawer"

import ClearIcon from "@mui/icons-material/Clear"

import {
  AchivedIcon,
  DrawerBox,
  DrawerBoxHeading,
  EventLogBox,
  EventLogSubBox,
  EventLogTypo,
  EventLogTypoText,
  MissedIcon,
} from "./Atom"
import { Divider, IconButton, Typography } from "@mui/material"
import { ActiveIcon } from "../../../Table/OpportunityDashboardTable/Atom"
import { useDispatch, useSelector } from "react-redux"

export default function OpportunityEventLogs(props: any) {
  const { isDrawerOpenLogs, setIsDrawerOpenLogs } = props
  const OpportunityLogs = useSelector((state: any) => {
    return state.metric.opportunityLogs
  })

  return (
    <div>
      <Box
        sx={{
          width: "100%",
          padding: 0,
        }}
      >
        {OpportunityLogs.length > 0 ? (
          <>
            {" "}
            {OpportunityLogs?.map((ele: any, index: any) => {
              return (
                <>
                  <EventLogBox key={index}>
                    <EventLogSubBox>
                      <EventLogTypo>Status</EventLogTypo>
                      <EventLogTypoText
                        sx={{
                          color:
                            ele.value === "active"
                              ? "#3366D6"
                              : ele.value === "achieved"
                              ? "#42B2A0"
                              : ele.value === "missed"
                              ? "#F15854"
                              : "",
                          display: "flex",
                          alignItems: "center",
                          textTransform: "capitalize",
                        }}
                      >
                        {ele.value === "active" ? (
                          <ActiveIcon />
                        ) : ele.value === "achieved" ? (
                          <AchivedIcon />
                        ) : ele.value === "missed" ? (
                          <MissedIcon />
                        ) : (
                          ""
                        )}
                        &nbsp; {ele.value}
                      </EventLogTypoText>
                    </EventLogSubBox>
                    <EventLogSubBox>
                      <EventLogTypo>Set By</EventLogTypo>
                      <EventLogTypoText>{`${ele.User?.first_name} ${ele.User?.last_name}`}</EventLogTypoText>
                    </EventLogSubBox>
                    <EventLogSubBox>
                      <EventLogTypo>Date</EventLogTypo>
                      <EventLogTypoText>{ele?.log_date}</EventLogTypoText>
                    </EventLogSubBox>
                  </EventLogBox>
                  <Divider />
                </>
              )
            })}
          </>
        ) : (
          <EventLogBox>
            <Typography> No Logs Found</Typography>
          </EventLogBox>
        )}
      </Box>
    </div>
  )
}
